export default "__VITE_ASSET__5cc493df__"